import { toast } from '@systemeio/ui';
import { BadRequest } from '@systemeio/util';
import { PipelineUpdateBody } from 'modules/crm/components/pipeline-update-body';
import { defaultErrors } from 'modules/crm/constants/default-errors';
import { usePipelineActions } from 'modules/crm/pipeline/hooks/use-pipeline-actions';
import { PipelineErrorsInterface } from 'modules/crm/pipeline/type/pipeline-errors-interface';
import { PipelineEditInterface, PipelineInterface } from 'modules/crm/types/pipeline-interface';
import React, { useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface CrmPipelineInterfaceProps {
  mutate: (response: PipelineInterface) => Promise<void>;
  pipeline: PipelineInterface;
  opened: boolean;
  onClose: () => void;
}
export const ModalEditPipeline = ({
  mutate,
  pipeline,
  opened,
  onClose
}: CrmPipelineInterfaceProps) => {
  const {
    t
  } = useLocoTranslation();
  const [tempState, setTempState] = useState<PipelineEditInterface>(pipeline);
  const [errors, setErrors] = useState<PipelineErrorsInterface>(defaultErrors);
  const {
    updatePipeline,
    isFetching: isFetchingUpdate
  } = usePipelineActions(pipeline.id);
  const updateCrmPipeline = async () => {
    try {
      setErrors(defaultErrors);
      if (tempState) {
        const newData = {
          id: tempState.id,
          name: tempState.name,
          stages: tempState?.stages.map(item => {
            if (item.id) {
              return {
                name: item.name,
                id: item.id
              };
            } else {
              return {
                name: item.name
              };
            }
          })
        };
        const response = await updatePipeline(newData);
        await mutate(response);
      }
      toast.success(t('global.changes_saved'));
      onClose();
    } catch (error) {
      if (error instanceof BadRequest) {
        const pipelineErrors = error.errors;
        if (pipelineErrors.fields) {
          setErrors(prev => {
            return {
              ...prev,
              fields: pipelineErrors.fields
            };
          });
        }
        if (pipelineErrors.common) {
          setErrors(prev_0 => {
            return {
              ...prev_0,
              common: pipelineErrors.common
            };
          });
        }
      } else {
        toast.error(t('global.error'));
      }
    }
  };
  const afterLeave = () => {
    setErrors(defaultErrors);
    setTempState(pipeline);
  };
  return <>
      {tempState !== undefined && <PipelineUpdateBody setTempState={setTempState} withConfirmation tempState={tempState} errors={errors} isUpdate={isFetchingUpdate} onClose={() => onClose()} afterLeave={afterLeave} isOpened={opened} saveCrmPipeline={updateCrmPipeline} modalTitle={t('dashboard.crm_pipeline.edit_modal.title')} />}
    </>;
};